import { render } from "./VerseText.vue?vue&type=template&id=5fc4cc9a&ts=true"
import script from "./VerseText.vue?vue&type=script&lang=ts"
export * from "./VerseText.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__